import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function ProductSection() {
  return <section className="py-10 px-4 bg-white relative" data-id="element-115">
      <div className="max-w-5xl mx-auto" data-id="element-116">
        <div className="text-center mb-10" data-id="element-117">
          <FadeIn data-id="element-118">
            <h2 className="text-4xl md:text-5xl font-bold text-burgundy-900 mb-6" data-id="element-119">
              Te presentamos CÓDIGO HIJO
            </h2>
          </FadeIn>
          <FadeIn delay={0.1} data-id="element-120">
            <p className="text-lg md:text-xl text-burgundy-700 max-w-2xl mx-auto leading-relaxed" data-id="element-121">
              La primera colección de guías prácticas de crianza consciente
              basada en la carta natal de tu hijo — escrita en lenguaje simple,
              sin tecnicismos y 100% accionable.
            </p>
          </FadeIn>
        </div>

        <FadeIn delay={0.3} data-id="element-122">
          <div className="relative w-full max-w-sm mx-auto" data-id="element-123">
            {/* Background glow */}
            <div className="absolute inset-0 bg-dusty-rose-200 rounded-full blur-3xl opacity-30 transform scale-125" data-id="element-124"></div>
            <img src="https://cdn.magicpatterns.com/uploads/5U9d4DqaxHqvgJs8hyMPTk/Diseno_sin_titulo_(41).png" alt="CÓDIGO HIJO — Colección completa: 6 Tomos + 3 Bonus" className="relative z-10 w-full h-auto drop-shadow-2xl" data-id="element-125" />
          </div>
        </FadeIn>
      </div>
    </section>;
}